export default "__VITE_ASSET__695c9423__"